// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WJsV","controls":"styles_controls__2qTKf","charLimit":"styles_charLimit__3-LWB","input":"styles_input__3_J8Y","send":"styles_send__2dms0"};